module.exports = __webpack_public_path__ + "img/tab_big.e0383be8.png";